// src/redux/actions/appointmentActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createAnthropometry, getAnthropometryByPatientId, deleteAnthropometry, getAnthropometryWithFilters } from '../../service/api';


// Create appointment
export const createNewAnthropometry = createAsyncThunk(
  'anthropometry/createNewAnthropometry',
  async (formData) => {
    const response = await createAnthropometry(formData);
    return response.data;
  }
);


//Get Anthropometry By Patient ID
export const fetchAnthropometryByPatientId = createAsyncThunk(
  'anthropometry/fetchAnthropometryByPatientId',
  async (patient_id, { rejectWithValue }) => {
    try {
      const data = await getAnthropometryByPatientId(patient_id);
      if (data && Array.isArray(data)) {
        // console.log("Dados processados da API:", data); // Verifique o que está sendo retornado
        return data; // Retorna diretamente o array de antropometrias
      }
      return []; // Retorna um array vazio se não houver dados
    } catch (error) {
      console.error("Erro ao buscar antropometria:", error);
      return rejectWithValue(error.message);
    }
  }
);


// Get Anthropometry Data (Reestruturado para usar createAsyncThunk)
export const fetchAnthropometryData = createAsyncThunk(
  'anthropometry/fetchAnthropometryData',
  async (patient_id, { rejectWithValue }) => {
    try {
      const data = await getAnthropometryByPatientId(patient_id);
      if (data && Array.isArray(data)) {
        // console.log("Dados processados da API:", data); // Verifique o que está sendo retornado
        return data; // Retorna diretamente o array de antropometrias
      }
      return []; // Retorna um array vazio se não houver dados
    } catch (error) {
      // console.error("Error fetching anthropometryData:", error);
      if (error.response?.status === 404) {
        console.info(`Nenhuma antropometria encontrada para o paciente ID ${patient_id}.`);
        return null; // Retorna null para indicar ausência de dados
      }
      console.error("Erro ao buscar antropometria:", error);
      return rejectWithValue(error.response?.data || error.message || "Erro desconhecido");; // Retorna o erro para ser tratado no extraReducers
    }
  }
);

// Delete Antropometria
export const deleteAnthropometryId = createAsyncThunk(
  'anthropometry/deleteAnthropometryId',
  async (anthropometry_id, { rejectWithValue }) => {
    try {
      const response = await deleteAnthropometry(anthropometry_id);
      // console.log(JSON.stringify(response.data))
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar antropometria:", error);
      return rejectWithValue(error.response.data);
    }
  }
);

// Busca com Filtros
export const fetchAnthropometryWithFilters = createAsyncThunk(
  'anthropometry/fetchAnthropometryWithFilters',
  async (filters, { rejectWithValue }) => {
    try {
      // Remove valores vazios/nulos antes de enviar
      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null && v !== '')
      );

      // console.log("Filtros sendo enviados:", cleanFilters);

      const queryParams = new URLSearchParams(cleanFilters).toString();
      const response = await getAnthropometryWithFilters(queryParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);